// core
import React from 'react';
// components
import LoginView from '@worklist-2/ui/src/views/LoginView';
// libs
import { Navigate } from 'react-router-dom';
// utils
import { useAuth } from '@rs-core/context/UserAuthContext';

export default function Login() {
	const { loggedIn } = useAuth();

	return loggedIn ? <Navigate replace to="/home" /> : <LoginView />;
}
